import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus, faUndo, faUsers } from "@fortawesome/free-solid-svg-icons";
const token = localStorage.getItem('token');

const TrashProjects = () => {
  const [deletedProjects, setDeletedProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeletedProjects();
  }, []);

  const fetchDeletedProjects = async () => {
    try {
      const res = await axios.get("/project?withDeleted=true", {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });

      const onlyDeleted = res.data.filter((p) => p.deletedAt !== null);
      setDeletedProjects(onlyDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des projets supprimés", error);
    }
  };

  const handleRestore = async (id) => {
    try {
      await axios.patch(`/project/recover/${id}`, null, {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });

      setDeletedProjects((prev) => prev.filter((project) => project.id !== id));
    } catch (error) {
      console.error("Erreur lors de la restauration du projet", error);
    }
  };

  return (
    <div className="p-6">
      <div className="top-bar">
              <h3>Projets supprimés</h3>
            <div>
            <button onClick={() => navigate("/admin/projects")} className="bout-trash">
              <FontAwesomeIcon icon={faUsers} style={{ marginRight: "8px" }} /> 
              Liste des projets
            </button>
            </div></div>
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 text-left">Nom</th>
            <th className="border px-4 py-2 text-left">État</th>
            <th className="border px-4 py-2 text-left">Début</th>
            <th className="border px-4 py-2 text-left">Fin</th>
            <th className="border px-4 py-2 text-left">Type</th>
            <th className="border px-4 py-2 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {deletedProjects.length > 0 ? (
            deletedProjects.map((project) => (
              <tr key={project.id}>
                <td className="border px-4 py-2">{project.projectName}</td>
                <td className="border px-4 py-2">{project.state}</td>
                <td className="border px-4 py-2">{project.startDate}</td>
                <td className="border px-4 py-2">{project.endDate}</td>
                <td className="border px-4 py-2">{project.serviceType}</td>
                <td className="border px-4 py-2">
                  <button
                    onClick={() => handleRestore(project.id)} className="icon-button text-red-600"
                  >
                    <FontAwesomeIcon icon={faUndo} />
                    
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center p-4" colSpan={6}>
                Aucun projet supprimé.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TrashProjects;
